export const subCategoryForTotal = {
	name: {
		en: 'All',
		ko: '전체',
	},
};

export const allCollectionCategoryList = isMobileMode => {
	let categoryList;

	if (!isMobileMode) {
		categoryList = [
			{
				name: {
					en: 'NFT Package',
					ko: 'NFT Package',
				},
				subCategories: [subCategoryForTotal],
			},
			{
				name: {
					en: 'Mystery Box',
					ko: 'Mystery Box',
				},
				subCategories: [subCategoryForTotal],
			},
			{
				name: {
					en: 'Product Card',
					ko: 'Product Card',
				},
				subCategories: [subCategoryForTotal],
			},
			{
				name: {
					en: 'PFP NFT',
					ko: 'PFP NFT',
				},
				subCategories: [
					subCategoryForTotal,
					{
						name: {
							en: 'DUMAN',
							ko: 'DUMAN',
						},
					},
				],
			},
			{
				name: {
					en: 'Membership Card',
					ko: 'Membership Card',
				},
				subCategories: [subCategoryForTotal],
			},
			{
				name: {
					en: 'Partners Utility Card',
					ko: 'Partners Utility Card',
				},
				subCategories: [subCategoryForTotal],
			},
		];
	} else {
		categoryList = [
			{
				name: {
					en: 'ALL',
					ko: 'ALL',
				},
				subCategories: [subCategoryForTotal],
			},
			{
				name: {
					en: 'Benefit Card',
					ko: '혜택 카드',
				},
				subCategories: [subCategoryForTotal],
			},
			{
				name: {
					en: 'NFT',
					ko: 'NFT',
				},
				subCategories: [subCategoryForTotal],
			},
			{
				name: {
					en: 'Package',
					ko: 'Package',
				},
				subCategories: [subCategoryForTotal],
			},
		];
	}

	return categoryList;
};
